// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"e0dd6fda","355":"5225597c","453":"8bd6d3d1","761":"d69ab416"}[chunkId] + ".chunk.js";
};